import Request from '@/api/request';
import { DadataBankResposeType, DadataPartyResponse } from '@/types/dadata';

const api = new Request('lk/dadata/');
/*
function dadataPost(method: string, body: unknown) {
  const url = `http://suggestions.dadata.ru/suggestions/api/4_1/rs/${method}`;
  const token = '0da1d1736c46264cfbe8b4d0bdbe952a5db0be2a';
  // const secret = '1f98f9ade82e2104b9b8dd1add9b28a9d26e4d77';

  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Token ' + token,
    },
    body: JSON.stringify(body),
  }).then((response) => response.json());
}
  */

function dadataPost(method: string, body: unknown) {
  return api.post(method, body);
}

export function findDadataBank(query: string): Promise<any> {
  return dadataPost('suggest/bank', { query }).then(parseDadataBankResponse);
}

export async function findDadataOrg(query: string) {
  const res = await dadataPost('suggest/party', {
    query,
  });
  return parseDadataPartyResponse(res);
}

export async function findDadataOrgById(query: string) {
  const res = await dadataPost('findById/suggest/party', {
    query,
  });
  return parseDadataPartyResponse(res);
}

function parseDadataAddress(
  data: DadataPartyResponse['suggestions'][number]['data']['address']
) {
  return {
    addressStr: data?.data?.source ?? '',
    isEsia: true,
    ...data?.data,
  };
}

function parseDadataDate(val: string) {
  if (!val) return '';
  const [dt] = new Date(val).toISOString().split('T');
  return dt.split('-').reverse().join('.');
}

function minName(...names: string[]) {
  return names.filter(Boolean).reduce((short, val) => {
    return !short || short.length > val.length ? val : short;
  }, '');
}

function parseDadataPartyResponse(res: DadataPartyResponse) {
  const ret =
    res.suggestions?.map((item) => ({
      name: item.data.name?.full_with_opf || item.value,
      shortName: minName(
        item.data.name?.short_with_opf,
        item.data.name?.full_with_opf,
        item.value
      ),
      address: parseDadataAddress(item.data.address),
      ogrn: item.data.ogrn,
      regDate: parseDadataDate(item.data.ogrn_date),
      inn: item.data.inn,
      kpp: item.data.kpp,
      email: item.data.emails?.[0]?.value ?? '',
      fioSurname: item.data.fio?.surname ?? '',
      fioName: item.data.fio?.name ?? '',
      fioPatronymic: item.data.fio?.patronymic ?? '',
    })) || [];
  return ret;
}

function parseDadataBankResponse(res: DadataBankResposeType) {
  return res.suggestions.map((item) => ({
    corrAccountNumber: item.data.correspondent_account,
    bankName: item.value,
    bic: item.data.bic,
  }));
}
